/* Állandó, görgethető FansBRANDS® alkategória-választó. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-fb-subcat-wrap]').forEach(wrap => {
      if (wrap.dataset.fbSubcatReady === 'true') return;
      const nav = wrap.querySelector('[data-fb-subcat-nav]');
      const next = wrap.querySelector('[data-fb-subcat-next]');
      const hint = wrap.parentElement.querySelector('[data-fb-subcat-hint]');
      if (!nav || !next) return;
      wrap.dataset.fbSubcatReady = 'true';
      function update() {
        const overflow = nav.scrollWidth > nav.clientWidth + 2;
        const atEnd = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 3;
        next.hidden = !overflow || atEnd;
        if (hint) {
          hint.hidden = !overflow;
          hint.textContent = atEnd ? 'Görgess balra a korábbi kategóriákért ←' : 'Húzd vagy görgesd jobbra a további kategóriákért →';
        }
      }
      next.addEventListener('click', () => {
        nav.scrollBy({left: Math.max(150, nav.clientWidth * .7), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
      nav.addEventListener('scroll',update,{passive:true});
      if (window.ResizeObserver) new ResizeObserver(update).observe(nav);
      else window.addEventListener('resize',update,{passive:true});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
